import { LOG_LEVELS_MAP as LEVELS, LOG_CONFIG_DEFAULT } from "./tabs";
let currentLevel = LEVELS.debug;
let adapter = null;

const stored = typeof window !== "undefined" ? localStorage.getItem("console_logs_config") : null;
let config = stored ? JSON.parse(stored) : { ...LOG_CONFIG_DEFAULT };

function emit(level, ...args) {
  if (!config.enabled) return;
  if (!config.levels[level]) return;
  if (LEVELS[level] < currentLevel) return;
  if (adapter) { adapter(level, ...args); return; }
  const prefix = `[${new Date().toISOString()}] [${level.toUpperCase()}]`;
  const fn = console[level] || console.log;
  fn(prefix, ...args);
}

export const logger = {
  debug: (...args) => emit("debug", ...args),
  info: (...args) => emit("info", ...args),
  warn: (...args) => emit("warn", ...args),
  error: (...args) => emit("error", ...args),
  setLevel(level) { currentLevel = LEVELS[level] ?? LEVELS.debug; },
  setAdapter(fn) { adapter = fn; },
  setConfig(newConfig) {
    config = { ...config, ...newConfig };
    if (newConfig.levels) config.levels = { ...config.levels, ...newConfig.levels };
    localStorage.setItem("console_logs_config", JSON.stringify(config));
  },
  getConfig() { return { ...config }; },
};
